export const EMAIL_REGEX = /\S+@\S+\.\S{2,}/
